<template>
  <section>
    <v-row>
      <v-col cols="12">
        <Crud
          title="Gestão de formações"
          buttonAddItemText="Nova formação"
          searchLabelText="Pesquisar na lista"
          :showButtonAddItem="$can('create', 'res-configuracao')"
          :searchTextField.sync="searchTextField"
          :formTitle="nameForm"
          :callBackModalCancelar="fechar"
          :dialog.sync="dialog"
          :callBackModalSalvar="salvar"
          :dialogDelete.sync="dialogDelete"
        >
          <template slot="data-content">
            <v-row class="mt-5">
              <!-- FILTRO CAMPOS -->
            </v-row>
          </template>
          <template slot="data-table">
            <v-data-table
              :headers="
                headers.filter((header) => {
                  return header.value != 'editar' && header.value != 'acao';
                })
              "
              :items="formacoes"
              class="elevation-5"
              :loading="loadingTable"
            >
              <!-- ACTIONS -->
              <template v-slot:[`item.actions`]="{ item }">
                <v-menu bottom left>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn icon v-bind="attrs" v-on="on">
                      <v-icon>mdi-dots-vertical</v-icon>
                    </v-btn>
                  </template>

                  <v-list>
                    <!-- Visualizar -->
                    <v-list-item v-if="$can('view', 'res-configuracao')">
                      <v-list-item-title>
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn icon v-bind="attrs" v-on="on">
                              <v-icon
                                class="actions"
                                @click="toggleModalLateral(item)"
                              >
                                mdi-eye
                              </v-icon>
                            </v-btn>
                          </template>
                          <span>Visualizar</span>
                        </v-tooltip>
                      </v-list-item-title>
                    </v-list-item>

                    <!-- Editar -->
                    <v-list-item v-if="$can('edit', 'res-configuracao')">
                      <v-list-item-title>
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn icon v-bind="attrs" v-on="on">
                              <v-icon class="actions" @click="editar(item)">
                                mdi-pencil
                              </v-icon>
                            </v-btn>
                          </template>
                          <span>Editar</span>
                        </v-tooltip>
                      </v-list-item-title>
                    </v-list-item>

                    <!-- Deletar -->
                    <v-list-item v-if="$can('delete', 'res-configuracao')">
                      <v-list-item-title>
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn icon v-bind="attrs" v-on="on">
                              <v-icon
                                class="actions"
                                @click="remover(item, true)"
                              >
                                mdi-delete
                              </v-icon>
                            </v-btn>
                          </template>
                          <span>Deletar</span>
                        </v-tooltip>
                      </v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </template>
              <template v-slot:[`item.created_at`]="{ item }">
                <span
                  >{{ item.created_at | dateFormatBr() }}
                  {{ item.created_at | timeFormatBr() }}h</span
                >
              </template>
            </v-data-table>
          </template>
          <!--------------- MODAL DE DELETE --------------------------------------------- -->
          <template slot="modalDelete/titleModal"> Excluir formação? </template>
          <template slot="modalDelete/contentModal">
            <p>
              Atenção! Você está prestes a realizar uma ação que não pode ser
              desfeita.
            </p>
            <p>Você realmente deseja excluir essa formação?</p>
          </template>
          <template slot="modalDelete/actionsModal">
            <v-btn depressed @click="dialogDelete = false">Fechar</v-btn>
            <v-btn
              :loading="loadingButtonDelete"
              color="error"
              @click="remover()"
            >
              Excluir
            </v-btn>
            <v-spacer class="d-none d-md-block"></v-spacer>
          </template>
          <!-- ------------- MODAL DE CADASTRO --------------------------------------------- -->
          <template slot="contentModalCrud">
            <FormacaoForm />
          </template>
        </Crud>
      </v-col>
    </v-row>

    <ModalLateral
      :show="modalLateral.show"
      :hide="toggleModalLateral"
      :title="modalLateral.title"
      :headers="headerModalLateral"
      :item="modalLateral.item"
    >
      <template v-slot:[`item.created_at`]="{ item }">
        <span
          >{{ item.created_at | dateFormatBr() }}
          {{ item.created_at | timeFormatBr() }}h</span
        >
      </template>
      <template v-slot:[`item.updated_at`]="{ item }">
        <span
          >{{ item.updated_at | dateFormatBr() }}
          {{ item.updated_at | timeFormatBr() }}h</span
        >
      </template>
    </ModalLateral>
  </section>
</template>

<script>
import Crud from "@/components/Crud.vue";
import ModalLateral from "@/components/ModalLateral.vue";
import FormacaoForm from "../components/FormacaoForm.vue";

export default {
  name: "FormacaoRES",
  inject: ["$validator"],
  components: {
    Crud,
    ModalLateral,
    FormacaoForm,
  },
  data() {
    return {
      nameForm: "Nova formação",
      modalLateral: {
        show: false,
        item: [],
        title: "",
      },
      searchTextField: "",
      dialog: false,
      loadingTable: false,
      headers: [
        { text: "Descrição", value: "descricao" },
        { text: "Data de criação", value: "created_at" },
        { text: "Ações", value: "actions" },
      ],
      headerModalLateral: [
        { text: "Descrição", value: "descricao" },
        { text: "Data de criação", value: "created_at" },
        { text: "Data de atualização", value: "updated_at" },
      ],

      dialogDelete: false,
      loadingButtonDelete: false,
      item: [],
    };
  },

  created() {
    this.loadingTable = true;

    this.$store.dispatch("resFormacoes/initialize").finally(() => {
      this.loadingTable = false;
    });
  },

  computed: {
    formacoes: {
      get() {
        return this.$store.getters["resFormacoes/getFormacoes"];
      },
    },
    formacao: {
      get() {
        return this.$store.getters["resFormacoes/getFormacao"];
      },
      set(value) {
        this.$store.dispatch("resFormacoes/setFormacao", value);
      },
    },
  },

  methods: {
    salvar() {
      this.$validator.validate("res_formacao.*").then((result) => {
        if (result) {
          const isEdit = this.formacao.id || this.formacao.uuid ? 1 : -1;

          this.dialog = false;
          this.loadingTable = true;
          let url =
            isEdit === -1
              ? "/res-formacao"
              : "/res-formacao/" + this.formacao.uuid;
          let method = isEdit === -1 ? "POST" : "PUT";
          let sucesso =
            isEdit === -1
              ? "Formação cadastrado com sucesso."
              : "Formação atualizado com sucesso.";
          let erro =
            isEdit === -1
              ? "Erro ao salvar formação."
              : "Erro ao atualizar formação.";

          let formacaoItem = this.formacao;
          formacaoItem._method = method;
          formacaoItem.url = url;

          this.$store
            .dispatch("resFormacoes/save", formacaoItem)
            .then((response) => {
              if (response != "NAO_AUTORIZADO") {
                if (isEdit === -1) {
                  this.formacoes.push(response);
                } else {
                  const index = this.formacoes.findIndex(
                    (el) => el.id == formacaoItem.id
                  );

                  Object.assign(this.formacoes[index], formacaoItem);
                }

                this.$store.dispatch("snackbar/ativarSnackbarGlobal", {
                  visibilidade: true,
                  mensagem: sucesso,
                  cor: "green",
                });
              }
            })
            .catch((error) => {
              console.error(error);
              this.$store.dispatch("snackbar/ativarSnackbarGlobal", {
                visibilidade: true,
                mensagem: erro,
                cor: "red",
              });
            })
            .finally(() => {
              this.fechar();
            });
        }
      });
    },
    editar(item) {
      this.loadingTable = true;

      this.$store
        .dispatch("resFormacoes/findByUuid", item.uuid)
        .then((response) => {
          this.formacao = response;
          this.nameForm = "Editar formação: " + this.formacao.descricao;
          this.dialog = true;
        })
        .catch(() => {
          this.$store.dispatch("snackbar/ativarSnackbarGlobal", {
            visibilidade: true,
            mensagem:
              "Houve um erro ao buscar todos os dados da formação selecionada.",
            cor: "red",
          });
        })
        .finally(() => {
          this.loadingTable = false;
        });
    },
    fechar() {
      this.dialog = false;
      this.loadingTable = false;
      this.nameForm = "Nova formação";
      this.formacao = {
        descricao: "",
      };
    },
    remover(item, openModal = false) {
      if (openModal) {
        this.item = Object.assign({}, item);
        this.dialogDelete = true;
      } else {
        this.loadingButtonDelete = true;
        const indexItem = this.formacoes.findIndex(
          (el) => el.id == this.item.id
        );

        this.$store
          .dispatch("resFormacoes/remove", this.item.uuid)
          .then((response) => {
            if (response) {
              this.formacoes.splice(indexItem, 1);

              this.$store.dispatch("snackBarModule/openSnackBar", {
                color: "success",
                timeout: 3000,
                text: "Formação removida.",
              });
              this.item = {};
            }
          })
          .catch(() => {
            this.$store.dispatch("snackBarModule/openSnackBar", {
              color: "error",
              timeout: 3000,
              text: "Não foi possível remover a formação.",
            });
          })
          .finally(() => {
            this.loadingButtonDelete = false;
            this.dialogDelete = false;
          });
      }
    },
    //Modal Lateral
    toggleModalLateral(item) {
      if (this.modalLateral.show == false) {
        this.loadingTable = true;

        this.$store
          .dispatch("resFormacoes/findByUuid", item.uuid)
          .then((response) => {
            this.modalLateral.title = response.descricao;
            this.modalLateral.item = response ? response : [];
            this.modalLateral.show = true;
          })
          .catch(() => {
            this.$store.dispatch("snackbar/ativarSnackbarGlobal", {
              visibilidade: true,
              mensagem:
                "Houve um erro ao buscar todos os dados da formação selecionada.",
              cor: "red",
            });
          })
          .finally(() => {
            this.loadingTable = false;
          });
      } else {
        this.modalLateral.show = false;
      }
    },
  },
};
</script>

<style scoped></style>
